export default {
 title: 'Mouy.app: Shop, buy and save!',
 motto: 'Everyday low prices.',
 comingSoon: 'Coming Soon!',
}
